import { Table } from "@renderbus/ui";
import { useAuthDetailTable } from "@/pages/authorization-management/components/auth-detail-table/hooks/useAuthDetailTable";
import { CustomStyleTable } from "./atoms.js";

export function AuthDetailTable({ className = "" }) {
  const { columns, tableData } = useAuthDetailTable();
  return (
    <>
      <Table
        className={`auth-detail-table ${className}`}
        columns={columns}
        dataSource={tableData}
        bordered
        hidePaginationOnSinglePage={true}
        pagination={false}
      />
      <CustomStyleTable />
    </>
  );
}
